import React, { useState } from "react";
import { Link, useNavigate } from "react-router";
import LeftNav from "../../components/leftNav/LeftNav";
import TopNav from "../../components/topNav/TopNav";
import { PaymentManagement } from "../../utils/interfaces/interfaces";

const Bills: React.FC = () => {
  const [bills] = useState<PaymentManagement[]>([
    {
      id: "1001",
      customerId: "C1",
      customer: {
        id: "C1",
        name: "Empresa ABC",
        cedulaJuridicaProveedor: "3-101-123456",
        emailProveedor: "example@domain.com",
        accountsIban: [
          {
            id: "iban1",
            name: "Cuenta Principal",
            ibanNumber: "CR12345678901234567890",
            currency: "CRC",
          },
          {
            id: "iban2",
            name: "Cuenta Secundaria",
            ibanNumber: "US09876543210987654321",
            currency: "USD",
          },
        ],
      },
      ibanId: "iban1",
      iban: {
        id: "iban1",
        name: "Cuenta Principal",
        ibanNumber: "CR12345678901234567890",
        currency: "CRC",
      },
      date: "2025-09-15",
      amount: 1200,
      state: "Pendiente",
      responsible: {
        id: "u1",
        name: "Juan Pérez",
      },
      responsibleId: "u1",
      record: [
        {
          id: "r1",
          name: "Creación de factura",
          description: "Factura creada el 2025-09-01",
        },
        {
          id: "r2",
          name: "Confirmacion de informacion",
          description: "Informacion completa 2025-09-01",
        },
      ],
      department: {
        id: "1",
        name: "Finanzas",
      },
      departmentId: "1",
      companyId: "1",
      company: {
        id: "1",
        name: "Empresa ABC",
        projects: [],
      },
      details: "Servicios de consultoría",
      bill: {
        id: "b1",
        dateBill: new Date().toISOString().split("T")[0],
        numberBill: "10001",
        dueDate: new Date().toISOString().split("T")[0],
        amount: 1200,
        state: "Pendiente",
        currency: "CRC",
      },
      billId: "b1",
      hasProjects: false,
      companyDepartmentId: "cd1",
      companyDepartment: {
        id: "cd1",
        name: "Departamento A",
      },
      companyDepartments: [
        {
          id: "cd1",
          name: "Departamento A",
        },
      ],
    },
  ]);

  let navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [filtroFecha, setFiltroFecha] = useState("");
  const [modalUpload, setModalUpload] = useState(false);
  const [modalFactura, setModalFactura] = useState<PaymentManagement | null>(
    null
  );

  const [bill, setBill] = useState<PaymentManagement | null>(null);

  const miDepartamento = "1";
  const [filtroDepartamento, setFiltroDepartamento] =
    useState<string>(miDepartamento);

  const billsFilter = bills.filter(
    (f) =>
      (f.customer.name.toLowerCase().includes(search.toLowerCase()) ||
        f.id.toString().includes(search)) &&
      (filtroFecha ? f.date === filtroFecha : true) &&
      (filtroDepartamento === "all"
        ? true
        : f.departmentId === filtroDepartamento)
  );

  const [searchResults, setSearchResults] = useState<any[]>([]);

  const fakeFacturas: PaymentManagement[] = [
    {
      id: "1001",
      customerId: "C1",
      hasProjects: false,
      customer: {
        id: "C1",
        name: "Empresa ABC",
        cedulaJuridicaProveedor: "3-101-123456",
        emailProveedor: "example@domain.com",
        accountsIban: [
          {
            id: "iban1",
            name: "Cuenta Principal",
            ibanNumber: "CR12345678901234567890",
            currency: "CRC",
          },
          {
            id: "iban2",
            name: "Cuenta Secundaria",
            ibanNumber: "US09876543210987654321",
            currency: "USD",
          },
        ],
      },
      ibanId: "iban1",
      iban: {
        id: "iban1",
        name: "Cuenta Principal",
        ibanNumber: "CR12345678901234567890",
        currency: "CRC",
      },
      date: "2025-09-15",
      amount: 1200,
      state: "Pendiente",
      responsible: {
        id: "u1",
        name: "Juan Pérez",
      },
      responsibleId: "u1",
      record: [
        {
          id: "r1",
          name: "Creación de factura",
          description: "Factura creada el 2025-09-01",
        },
      ],
      department: {
        id: "1",
        name: "Finanzas",
      },
      departmentId: "1",
      companyId: "1",
      company: {
        id: "1",
        name: "Empresa ABC",
        projects: [],
      },
      details: "Servicios de consultoría",
      bill: {
        id: "b1",
        dateBill: new Date().toISOString().split("T")[0],
        numberBill: "10001",
        dueDate: new Date().toISOString().split("T")[0],
        amount: 1200,
        state: "Pendiente",
        currency: "CRC",
      },
      billId: "b1",
      companyDepartmentId: "cd1",
      companyDepartment: {
        id: "cd1",
        name: "Departamento A",
      },
      companyDepartments: [
        {
          id: "cd1",
          name: "Departamento A",
        },
      ],
    },
    {
      id: "1002",
      customerId: "C2",
      customer: {
        id: "C2",
        name: "Servicios XYZ",
        cedulaJuridicaProveedor: "3-101-123456",
        emailProveedor: "example@domain.com",
        accountsIban: [
          {
            id: "iban1",
            name: "Cuenta Principal",
            ibanNumber: "CR12345678901234567890",
            currency: "CRC",
          },
          {
            id: "iban2",
            name: "Cuenta Secundaria",
            ibanNumber: "US09876543210987654321",
            currency: "USD",
          },
        ],
      },
      ibanId: "iban2",
      hasProjects: false,
      iban: {
        id: "iban2",
        name: "Cuenta Secundaria",
        ibanNumber: "US09876543210987654321",
        currency: "USD",
      },
      date: "2025-09-15",
      amount: 2010,
      state: "Aprobada",
      responsible: {
        id: "u1",
        name: "Juan Pérez",
      },
      responsibleId: "u1",
      record: [
        {
          id: "r1",
          name: "Creación de factura",
          description: "Factura creada el 2025-09-01",
        },
      ],
      department: {
        id: "2",
        name: "Compras",
      },
      departmentId: "2",
      companyId: "2",
      company: {
        id: "2",
        name: "Servicios XYZ",
        projects: [],
      },
      details: "Servicios de consultoría",
      bill: {
        id: "b2",
        dateBill: new Date().toISOString().split("T")[0],
        numberBill: "10002",
        dueDate: new Date().toISOString().split("T")[0],
        amount: 1200,
        state: "Pendiente",
        currency: "USD",
      },
      billId: "b2",
      companyDepartmentId: "cd1",
      companyDepartment: {
        id: "cd1",
        name: "Departamento A",
      },
      companyDepartments: [
        {
          id: "cd1",
          name: "Departamento A",
        },
      ],
    },
  ];

  const handleSearchChange = (value: string) => {
    setBill(
      bill
        ? { ...bill, searchNewPayment: value }
        : { ...fakeFacturas[0], searchNewPayment: value }
    );
    if (!value.trim()) {
      setSearchResults([]);
      return;
    }

    const results = fakeFacturas.filter(
      (f) =>
        f.customer.name.toLowerCase().includes(value.toLowerCase()) ||
        f.bill.numberBill.toLowerCase().includes(value.toLowerCase()) ||
        f.billId.toString().includes(value)
    );

    console.log("Resultados de búsqueda:", results);

    setSearchResults(results);
  };

  const handleSelectFactura = (factura: PaymentManagement) => {
    setBill({
      ...factura,
      bill: {
        ...factura.bill,
        id: factura.bill.id,
        numberBill: factura.bill.numberBill,
        amount: factura.bill.amount,
        dateBill: factura.bill.dateBill,
      },
      customer: factura.customer,
      customerId: factura.customerId,
    });
    setSearchResults([]);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <LeftNav />

      <div className="flex flex-1 flex-col">
        <TopNav />

        <main className="flex-1 overflow-y-auto p-6">
          <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex flex-wrap gap-4">
              <label className="flex flex-col text-sm text-gray-700">
                Fecha
                <input
                  type="date"
                  value={filtroFecha}
                  onChange={(e) => setFiltroFecha(e.target.value)}
                  className="mt-1 rounded-lg border border-gray-300 px-3 py-2 text-sm"
                />
              </label>

              <label className="flex flex-col text-sm text-gray-700">
                Departamento
                <select
                  value={filtroDepartamento}
                  onChange={(e) => setFiltroDepartamento(e.target.value)}
                  className="mt-1 rounded-lg border border-gray-300 px-3 py-2 text-sm"
                >
                  <option value="all">Todos</option>
                  <option value="1">Finanzas</option>
                  <option value="2">Compras</option>
                  <option value="3">Contabilidad</option>
                </select>
              </label>

              <label className="flex flex-col text-sm text-gray-700">
                Buscar
                <input
                  type="text"
                  placeholder="Proveedor o # factura"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="mt-1 rounded-lg border border-gray-300 px-3 py-2 text-sm"
                />
              </label>
            </div>

            <div className="flex gap-2">
              <button
                onClick={() => setModalUpload(true)}
                className="rounded-lg bg-green-600 px-4 py-2 text-white hover:bg-green-700"
              >
                Agendar Pago
              </button>
            </div>
          </div>

          <div className="overflow-x-auto rounded-lg shadow">
            <table className="w-full border-collapse bg-white text-sm">
              <thead>
                <tr className="bg-gray-100 text-left text-gray-600">
                  <th className="px-4 py-3">#</th>
                  <th className="px-4 py-3">Proveedor</th>
                  <th className="px-4 py-3">Empresa</th>
                  <th className="px-4 py-3">Fecha</th>
                  <th className="px-4 py-3">Monto</th>
                  <th className="px-4 py-3">Estado</th>
                  <th className="px-4 py-3">Departamento</th>
                  <th className="px-4 py-3">Responsable / Etapa</th>
                  <th className="px-4 py-3">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {billsFilter.map((bill) => (
                  <tr key={bill.id} className="border-t hover:bg-gray-50">
                    <td className="px-4 py-3">{bill.id}</td>
                    <td className="px-4 py-3">{bill.customer.name}</td>
                    <td className="px-4 py-3">{bill.company.name}</td>
                    <td className="px-4 py-3">{bill.date}</td>
                    <td className="px-4 py-3 font-medium text-blue-600">
                      ${bill.amount}
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`rounded-full px-3 py-1 text-xs font-semibold ${
                          bill.state === "Pendiente"
                            ? "bg-yellow-100 text-yellow-700"
                            : bill.state === "Aprobada"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {bill.state}
                      </span>
                    </td>
                    <td className="px-4 py-3">{bill.department.name}</td>
                    <td className="px-4 py-3">{bill.responsible.name}</td>
                    <td className="px-4 py-3 flex gap-2">
                      <button
                        onClick={() => setModalFactura(bill)}
                        className="rounded-lg bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
                      >
                        Vista rápida
                      </button>
                      <Link
                        to={`/bills/${bill.id}`}
                        className="rounded-lg bg-gray-500 px-4 py-2 text-white hover:bg-gray-600"
                      >
                        Ver
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </main>
      </div>

      {modalUpload && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="w-full max-w-lg rounded-lg bg-white p-6 shadow-lg">
            <h2 className="mb-4 text-lg font-semibold text-gray-800">
              Agendar Pago
            </h2>

            <div className="space-y-3 relative">
              <label className="block text-sm">
                Buscar Factura por nombre, número de factura o cédula
                <input
                  className="mt-1 w-full rounded border p-2"
                  type="text"
                  value={bill?.searchNewPayment}
                  onChange={(e) => handleSearchChange(e.target.value)}
                  placeholder="Ejemplo: Empresa ABC, #1234 o 1-234-567"
                />
              </label>

              {searchResults.length > 0 && (
                <ul className="absolute z-50 mt-1 w-full rounded border bg-white shadow max-h-40 overflow-y-auto">
                  {searchResults.map((item) => (
                    <li
                      key={item.id}
                      onClick={() => handleSelectFactura(item)}
                      className="cursor-pointer px-3 py-2 hover:bg-gray-100 text-sm"
                    >
                      <span className="font-medium">{item.customer.name}</span>{" "}
                      — #{item.bill.numberBill} — ₡{item.bill.amount}
                    </li>
                  ))}
                </ul>
              )}

              {bill?.id && (
                <>
                  <label className="block text-sm">
                    Fecha Factura
                    <input
                      type="date"
                      value={bill.bill.dateBill}
                      onChange={(e) =>
                        setBill({
                          ...bill,
                          bill: {
                            ...bill.bill,
                            dateBill: e.target.value,
                          },
                        })
                      }
                      className="mt-1 w-full rounded border p-2 disabled:cursor-not-allowed"
                      disabled
                    />
                  </label>

                  <label className="block text-sm">
                    Número Factura
                    <input
                      type="text"
                      value={bill.bill.numberBill}
                      onChange={(e) =>
                        setBill({
                          ...bill,
                          bill: {
                            ...bill.bill,
                            numberBill: e.target.value,
                          },
                        })
                      }
                      className="mt-1 w-full rounded border p-2 disabled:cursor-not-allowed"
                      disabled
                    />
                  </label>

                  <label className="block text-sm">
                    Monto
                    <input
                      type="number"
                      value={bill.bill.amount}
                      onChange={(e) =>
                        setBill({
                          ...bill,
                          bill: {
                            ...bill.bill,
                            amount: e.target.value
                              ? parseFloat(e.target.value)
                              : 0,
                          },
                        })
                      }
                      className="mt-1 w-full rounded border p-2 disabled:cursor-not-allowed"
                      disabled
                    />
                  </label>
                </>
              )}
            </div>

            <div className="mt-6 flex justify-end gap-2">
              <button
                onClick={() => setModalUpload(false)}
                className="rounded-lg bg-gray-300 px-4 py-2 hover:bg-gray-400"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  console.log("Factura lista para guardar:", bill);
                  setBill(null);
                  navigate(`/bills/${bill?.id}`);
                  setModalUpload(false);
                }}
                className="rounded-lg bg-green-600 px-4 py-2 text-white hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
                disabled={!bill?.id}
              >
                Agendar Pago
              </button>
            </div>
          </div>
        </div>
      )}

      {modalFactura && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
          <div className="w-full max-w-lg rounded-lg bg-white p-6 shadow">
            <h2 className="mb-4 text-lg font-semibold text-gray-800">
              Factura #{modalFactura.id}
            </h2>
            <p>
              <strong>Cliente:</strong> {modalFactura.customer.name}
            </p>
            <p>
              <strong>Fecha:</strong> {modalFactura.date}
            </p>
            <p>
              <strong>Monto:</strong> ${modalFactura.amount}
            </p>
            <p>
              <strong>Estado:</strong> {modalFactura.state}
            </p>
            <p>
              <strong>Departamento:</strong> {modalFactura.department.name}
            </p>
            <p>
              <strong>Responsable:</strong> {modalFactura.responsible.name}
            </p>
            <div className="mt-4">
              <h3 className="mb-2 font-medium">Historial:</h3>
              <ul className="list-disc pl-6 text-sm text-gray-600">
                {modalFactura.record.map((h, i) => (
                  <li key={h.id}>
                    <strong>{h.name}</strong>: {h.description}
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-6 flex justify-end gap-2">
              <button
                onClick={() => setModalFactura(null)}
                className="rounded-lg bg-gray-300 px-4 py-2 hover:bg-gray-400"
              >
                Cerrar
              </button>
              {/*
              <button
                onClick={() => alert("Aprobar factura")}
                className="rounded-lg bg-green-600 px-4 py-2 text-white hover:bg-green-700"
              >
                Aprobar
              </button>
              <button
                onClick={() => alert("Devolver factura")}
                className="rounded-lg bg-red-600 px-4 py-2 text-white hover:bg-red-700"
              >
                Devolver
              </button>
*/}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Bills;
